import React from 'react';

import type { CardsContentWithLink } from '../types';
import Schedule from './Schedule';
import Status from './Status';
import Tags from './Tags';
import Targeting from './Targeting';

export const adsCardsContent = (): Array<CardsContentWithLink> => [
  {
    sideNavLink: 'Status',
    cardContent: (isExpanded, entityType): JSX.Element => <Status isExpanded={isExpanded} entityType={entityType} />,
  },
  {
    sideNavLink: 'Targeting',
    cardContent: (_, entityType): JSX.Element => <Targeting entityType={entityType} />,
  },
  {
    sideNavLink: 'Scheduling',
    cardContent: (): JSX.Element => <Schedule />,
  },
  {
    sideNavLink: 'Tags',
    cardContent: (isExpanded): JSX.Element => <Tags isExpanded={isExpanded} />,
    title: 'Tags for Third Party Measurement',
  },
];
